import { FETCH_ALL_PRODUCTFLOWS, FETCH_PAGINATE_PRODUCTFLOWS, FETCH_CURRENT_PRODUCTFLOW, FETCH_ALL_PRODUCTFLOW_ORDERS } from './../../mutation-types';

export default {
  [FETCH_ALL_PRODUCTFLOWS](state, productFlows) {
    state.all = productFlows;
  },

  [FETCH_PAGINATE_PRODUCTFLOWS](state, { productFlows, pagination }) {
    state.items = productFlows;
    state.pagination = pagination;
  },

  [FETCH_CURRENT_PRODUCTFLOW](state, productFlow) {
    state.current_PRODUCTFLOW = productFlow;
  },

  [FETCH_ALL_PRODUCTFLOW_ORDERS](state, orders) {
    state.orders = orders;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productFlow/mutations.js